<template>
    <div class="selection__wrapper" :class="{ selection__isSelected: isLinkSelected ? false : isSelected, selection__isLink: isLink, selection__isDisabled: !!isDisabled }" @click="handleClick">
        <div v-if="imageUrl" class="selection__img-wrapper">
            <img class="selection__img" :src="imageUrlWithParam" />
        </div>
        <div v-else class="selection__img-fallback">
            <font-awesome-icon :icon="['fa-thin', 'fa-circle-quarters']" class="selection__img-fallback-icon" />
        </div>

        <div class="selection__text-wrapper">
            <div class="selection__title-wrapper">
                <h4 class="selection__title">{{ displayName }}</h4>
                <div class="selection__compatibility" v-if="!!compatibilityMessage"><IconTooltip :tooltipMessage="compatibilityMessage" :isHtml="true"></IconTooltip></div>
            </div>
            <p class="selection__description" v-if="!!description" v-html="descriptionOrLink"></p>
        </div>
	    <button v-if="clearSelections?.length" class="selection__reset-lock" @click="resetSelections" title="Remove Lock">&times;</button>
        <div v-if="!!route" class="selection__action-item">
            <font-awesome-icon :icon="['fa-thin', 'fa-chevron-right']" class="selection__action-item-icon" />
        </div>
    </div>
</template>

<script setup lang="ts">
import IconTooltip from './shared/IconTooltip.vue';
import { computed, onMounted} from 'vue';
import {useStore} from "vuex";
const store = useStore();

const props = defineProps({
    id: String,
    displayName: String,
    description: String,
    imageUrl: String,
    route: String,
    isSelected: Boolean,
    isDisabled: Boolean,
    fieldId: String,
    categoryType: String,
    compatibilityMessage: String,
    productDetailPageUrl: String,
    compatibilityModalMessage: String,
	clearSelections: {
		type: Array,
		default: () => []
	}
});
const emit = defineEmits(['update-route', 'update-selection']);
const imageUrlWithParam = computed(() => {
	return props.imageUrl.includes("transparentbackground") ? (props.imageUrl.includes("?") ? `${props.imageUrl}&fmt=png-alpha` : `${props.imageUrl}?fmt=png-alpha`) : props.imageUrl;
});

const resetSelections = (event) => {
	event.stopPropagation();
	store.dispatch('removeLock', props);
};

const isLink = computed(() => {
    return !!props.route;
});
const isLinkSelected = computed(() => {
    return !!props.route && props.isSelected;
});

const descriptionOrLink = computed(() => {
    return props.productDetailPageUrl ? `<a href="${props.productDetailPageUrl}" target="_blank">${props.description}</a>` : props.description;
});

function handleClick() {
    if (!!props.route) {
        emit('update-route', props.route);
    } else if (!!props.fieldId) {
        emit('update-selection', { selection: props, fieldId: props.fieldId });
    }
}
</script>
